
<template>
  <div class="modal-overlay" @click.self="close">
    <div class="modal-card">

      <!-- Close Icon -->
      <button class="close-icon" @click="close">
        <svg width="22" height="22" viewBox="0 0 24 24">
          <path d="M6 6L18 18M6 18L18 6" stroke="#333" stroke-width="2" stroke-linecap="round" />
        </svg>
      </button>

      <h2 class="modal-title">User Details</h2>

      <div class="details-row">
        <span class="label">Name:</span>
        <span class="value">{{ data?.name ?? "N/A" }}</span>
      </div>

      <div class="details-row">
        <span class="label">Email:</span>
        <span class="value">{{ data?.email ?? "support@renants.com" }}</span>
      </div>

      <div class="details-row">
        <span class="label">Phone:</span>
        <span class="value">{{ data?.phone ?? "+1 347-309-5344" }}</span>
      </div>

      <div class="details-row">
        <span class="label">Location:</span>
        <span class="value">{{ data?.location ?? "N/A" }}</span>
      </div>

    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  data: { type: Object, required: true ,default: () => ({}) }
})
const emit = defineEmits(["close"])
const close = () => emit("close")
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 6000;
}

.modal-card {
  width: 380px;
  padding: 26px 24px;
  background: #fff;
  border-radius: 16px;
  position: relative;
  animation: fadeIn .25s ease;
}

.modal-title {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 16px;
}

.details-row {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}

.label {
  font-weight: 600;
  color: #444;
}

.value {
  font-weight: 500;
  text-align: right;
  max-width: 70%;
  word-break: break-word;
}

.close-icon {
  position: absolute;
  top: 14px;
  right: 14px;
  border: none;
  background: none;
  cursor: pointer;
  padding: 4px;
}

@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.98); }
  to { opacity: 1; transform: scale(1); }
}
</style>
